export default __webpack_public_path__ + "static/media/Delete.af56893e.svg";